import { MESSAGES } from './Messages';
import { toast } from 'react-toastify';

export const agentIsPausedOrLoggedOut = (messageSendingBlocked) => {
  if (!messageSendingBlocked) return false;

  toast.warning(MESSAGES.ON_PAUSE_OR_NOT_LOGGED, {
    autoClose: 3000,
    closeOnClick: true
  });
  return true;
};
